import {gsap} from "../LibrariesImport";

export default class BlockImage {
	static init() {

		// const blocks = document.querySelectorAll('.block-image');
		// blocks.forEach( block => {
		// 	const image = block.querySelector('.image');
		//
		// 	gsap.to(image, {
		// 		"--clip-top": "0%",
		// 		"--clip-right": "0%",
		// 		"--clip-bottom": "0%",
		// 		"--clip-left": "0%",
		// 		scrollTrigger: {
		// 			trigger: image,
		// 			start: "top bottom",
		// 			end: "bottom center",
		// 			scrub: true
		// 		}
		// 	});
		// });

	}
}
